export const Endpoints = {
    AUTH :{
        LOGIN: `admin/auth/login`,
        FORGET_PASSWORD: `admin/auth/forgot/password`,
        RESET_PASSWORD: `admin/auth/reset/password`,
        VERIFY_OTP: `admin/auth/verify/otp`,
        RESENT_OTP: `admin/auth/resend/otp`,
        LOGOUT: `admin/auth/logout`,
        REFRESH_TOKEN:'admin/auth/refresh/token'
    },
    NON_AUTH:{
        CHANGE_PASSWORD: `admin/auth/change/password`,
        DASHBOARD_DATA: `admin/dashboard/get`,
        USER_GRAPH:'admin/dashboard/users',
        REVENUE_GRAPH:'admin/dashboard/subscriptions',
        USER_LIST:'admin/user/list',
        USER_DETAILS:'admin/user/details',
        USER_STATUS_UPDATE:'admin/user/status',
        COMMON_CONTENT:'common/common_content',
        COMMON_CONTENT_UPDATE:'admin/common/common_content',
        FAQ_LIST:'common/questions',
        FAQ_Add_UPDATE:'admin/common/question',
        COMMUNITY_LIST:'admin/community/list',
        COMMUNITY_DETAIL:'admin/community/details',
        COMMUNITY_ADD:'admin/community/add',
        COMMUNITY_UPDATE:'admin/community/update',
        COMMUNITY_DELETE:'admin/community/delete',
        CATEGORY_LIST:'admin/gtk/category/list',
        CATEGORY_ADD:'admin/gtk/category/add',
        CATEGORY_UPDATE:'admin/gtk/category/update',
        REPORT_USER_LIST:'admin/report/users/list',
        REPORT_POST_LIST:'admin/report/post/list',
        REPORT_POST_DETAIL:'admin/report/post/details',
        REPORT_POST_DELETE:'admin/report/post/delete',
        REPORT_COMMENT_LIST:'admin/report/comments/list',
        REPORT_COMMENT_DETAIL:'admin/report/comment/details',
        REPORT_COMMENT_DELETE:'admin/report/comment/delete',
    },
}